<template>
  <div class="">
    <CRow class="w-100">
      <CCol md="12" lg="12" sm="12" xs="12">
        <HomeMaintenceVue v-if="page == 'home'" @changePage="changePage" @setView="setView" />
        <RolesVue class="pt-3" v-if="page == 'roles'" @mtdBack="mtdBack" />
        <UsersVue class="pt-3" v-if="page == 'users'" @mtdBack="mtdBack" />
        
        <ClientIseaVue v-if="$store.getters.get_company.id == 11 && page == 'clients'" class="pt-3" @mtdBack="mtdBack" />
        <ClientVue v-else-if="page == 'clients'" class="pt-3" @mtdBack="mtdBack" />

        <CampusVue class="pt-3" v-if="page == 'campus'" @mtdBack="mtdBack" />
        <BoxVue class="pt-3" v-if="page == 'boxes'" @mtdBack="mtdBack" />

        <ServiceIseaVue class="pt-3" v-if="$store.getters.get_company.id == 11 && page == 'services'" @mtdBack="mtdBack" />
        <ServiceVue class="pt-3" v-else-if="$store.getters.get_company.id != 11 && page == 'services'" @mtdBack="mtdBack" />
        
        <MaterialIseaVue class="pt-3" v-if="$store.getters.get_company.id == 11 && page == 'materials'" @mtdBack="mtdBack" />
        <!-- <TratamientoIseaVue class="pt-3" v-if="$store.getters.get_company.id == 11 && page == 'treatments'" @mtdBack="mtdBack" /> -->
        
        <JobPositionVue class="pt-3" v-if="page == 'job_positions'" @mtdBack="mtdBack" />
        <BarberVue class="pt-3" v-if="page == 'barbers'" @mtdBack="mtdBack" />
        <RecepcionistVue class="pt-3" v-if="page == 'recepcionists'" @mtdBack="mtdBack" />
        <ProductVue class="pt-3" v-if="page == 'products'" @mtdBack="mtdBack" />
        <UnitsVue class="pt-3" v-if="page == 'units'" @mtdBack="mtdBack" />
        <CompanyVue class="pt-3" v-if="page == 'companies'" @mtdBack="mtdBack" />
        <DocumentTypeVue class="pt-3" v-if="page == 'document_type'" @mtdBack="mtdBack" />
        <MethodPaymentVue class="pt-3" v-if="page == 'method_payment'" @mtdBack="mtdBack" />
        <ProveiderVue class="pt-3" v-if="page == 'provider'" @mtdBack="mtdBack" />
        <servicetypeVue class="pt-3" v-if="page == 'servicetype'" @mtdBack="mtdBack" />
        <PersonalKatalynas class="pt-3" v-if="$store.getters.get_company.id == 10 && page == 'personal'" @mtdBack="mtdBack"/>
        <Personal class="pt-3" v-else-if="page == 'personal'" @mtdBack="mtdBack"/>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BoxVue from "../../components/maintenance/Box.vue";
import CampusVue from "../../components/maintenance/Campus.vue";

import ServiceVue from "../../components/maintenance/Service.vue";
import ServiceIseaVue from "../../components/maintenance/isea/Tratamiento.vue";

import MaterialIseaVue from "../../components/maintenance/isea/Material.vue";
// import TratamientoIseaVue from "../../components/maintenance/isea/Tratamiento.vue";

import ClientIseaVue from '../../components/maintenance/isea/Client.vue';
import ClientVue from '../../components/maintenance/Client.vue';

import JobPositionVue from "../../components/maintenance/JobPositon.vue";
import BarberVue from "../../components/maintenance/Barber.vue";
import RecepcionistVue from "../../components/maintenance/Recepcionist.vue";
import HomeMaintenceVue from "../../components/maintenance/home.vue";
import ProductVue from "../../components/maintenance/Product.vue"
import UnitsVue from "../../components/maintenance/Unit.vue"
import RolesVue from "../access/roles.vue";
import UsersVue from "../access/users.vue";
import CompanyVue from "../../components/maintenance/Company.vue";
import DocumentTypeVue from "../../components/maintenance/DocumentType.vue";
import MethodPaymentVue from "../../components/maintenance/MethodPayment.vue";
import ProveiderVue from "../../components/maintenance/Proveider.vue";
import servicetypeVue from '../../components/maintenance/servicetype.vue';
import Personal from "../../components/maintenance/personal/Personal.vue";
import PersonalKatalynas from "../../components/maintenance/personal/Katalynas/Personal.vue";


export default {
  components: {
    HomeMaintenceVue,
    RolesVue,
    UsersVue,
    CampusVue,
    BoxVue,
    ServiceVue,
    JobPositionVue,
    BarberVue, 
    RecepcionistVue, 
    ProductVue, 
    UnitsVue, 
    CompanyVue, 
    DocumentTypeVue, 
    MethodPaymentVue,
    ProveiderVue,
    servicetypeVue,
    ClientVue,
    ClientIseaVue,
    Personal,
    PersonalKatalynas,
    ServiceIseaVue,
    MaterialIseaVue,
    // TratamientoIseaVue
  },
  data() {
    return {
      page: "home",
    };
  },
  methods: {
    changePage: function (page) {
      this.page = page;
    },
    mtdBack: function () {
      this.page = 'home';
    },
    setView: function(){
      this.$emit('setView', 'home')
    }
  },
};
</script>
